import { render, staticRenderFns } from "./HouseholdAddApp.vue?vue&type=template&id=56f2f89e&scoped=true&"
import script from "./HouseholdAddApp.vue?vue&type=script&lang=js&"
export * from "./HouseholdAddApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f2f89e",
  null
  
)

export default component.exports